import miayerM from '../../assets/images/miamr_m.png';
import AnimatedBackground from './AnimatedBackground';

interface Props {
  children: React.ReactNode;
}

const LoginContainer = ({ children }: Props) => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Animated Background */}
      <AnimatedBackground />

      {/* Content */}
      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        {/* Left Image Section */}
        <div className="hidden lg:flex items-center justify-center px-10">
          <img src={miayerM} alt="Mieyar" className="max-w-[550px] w-full object-contain" />
        </div>

        {/* Right Login Card */}
        <div className="flex items-center justify-center px-6">{children}</div>
      </div>
    </div>
  );
};

export default LoginContainer;
